var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpIconnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.599 8.54232C10.3312 8.81011 9.89701 8.81011 9.62922 8.54232L5.9998 4.91291L2.37039 8.54232C2.1026 8.81011 1.66843 8.81011 1.40065 8.54232C1.13286 8.27454 1.13286 7.84036 1.40065 7.57258L5.51493 3.45829C5.78272 3.1905 6.21689 3.1905 6.48468 3.45829L10.599 7.57258C10.8668 7.84037 10.8668 8.27454 10.599 8.54232Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIconnew);
export default __webpack_public_path__ + "static/media/upIconnew.1df0538d591e04ac4a01d5b5cd4e6c80.svg";
export { ForwardRef as ReactComponent };